import { defineStore } from 'pinia'
import useGet from '../core/composables/api/useGet'
import type { User } from '../core/models/user'
import { ApiRequestStatus } from '../core/models/api/api-request-status'
import { EventKey } from '../core/events/event-key'
import { useEventBus } from '@vueuse/core'

export const useUserStore = defineStore('user', {
  state: () => ({
    _user: null as User | null,
  }),

  getters: {
    user(state): User {
      if (!state._user) {
        throw new Error('User not initialized')
      }
      return state._user
    },
  },

  actions: {
    async loadUser() {
      const { data, status, load, reload } = useGet<User>('user')
      await load()

      if (status.value !== ApiRequestStatus.Success) {
        throw new Error('Could not load user')
      }

      const updatedMemberPermissionsBus = useEventBus(EventKey.updatedMemberPermissions)
      updatedMemberPermissionsBus.on(async (payload) => {
        if (payload.memberId == this._user?.id) {
          await reload()
          this._user = data.value
        }
      })

      this._user = data.value
    },
  },
})
